import { Component, EventEmitter, Input, OnInit, OnChanges, Output } from '@angular/core';
import { TreeModel } from 'app/shared/components/tree/tree-model';

import * as _ from 'lodash';

@Component({
  selector: 'bz-tree',
  templateUrl: 'tree.component.html',
  styleUrls: ['tree.component.scss']
})
export class BzTreeComponent implements OnInit, OnChanges {

  @Input() tree: Array<TreeModel>;
  @Input() currentId: string;
  @Input() currentParentId: string;
  @Output() clickNodeEvent: EventEmitter<any> = new EventEmitter<any>();

  loading: boolean;

  ngOnInit() {
    this.loading = false;
  }

  ngOnChanges(changes: any) {
    if (this.loading === true && changes && changes.tree && changes.tree.currentValue) {
      this.loading = false;
    }
  }

  public getInfo(item: TreeModel) {
    if (this.isClickable(item)) {
      if (item.children.length <= 0 || item.canExpandAndDetail) {
        this.clickNodeEvent.emit(item);
      }
      const newTree = _.find(this.tree, { id: item.id, value: item.value });
      if (newTree) {
        newTree.isExpanded = !item.isExpanded;
      }
    }
  }

  public isSelected(item: TreeModel): boolean {
    return item.id === this.currentId && (item.parentId === this.currentParentId || item.type === this.currentParentId)
  }
  public isClickable(item: TreeModel) {
    return (item.iconClass && item.iconClass == '#key' && item.hasNodes) ||
    (item.iconClass && item.iconClass == '#keys' && item.id);
  }
}
